import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import {
  add_metabse_links,
  update_metabse_links,
} from "../../data/ApiEndpoints";

const MetabseLinkForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    dashboardName:
      isEdit && rowData?.dashboard_name ? rowData.dashboard_name : "",
    publicUrl: isEdit && rowData?.public_url ? rowData.public_url : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = (formValues) => {
    let errors = {};
    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/;

    if (!formValues.dashboardName) {
      errors.dashboardName = "Required!";
    }

    if (!formValues.publicUrl) {
      errors.publicUrl = "Required!";
    } else if (!urlRegex.test(formValues.publicUrl)) {
      errors.publicUrl = `Invalid route path! A valid route starts with "/" and contains only alphanumeric characters, "-", "_", or "/".`;
    }

    return errors;
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_metabse_links : add_metabse_links;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        dashboard_name: formValues.dashboardName ?? "",
        public_url: formValues.publicUrl ?? "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Metabase Link`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="dashboardName" className={`formInputLabel `}>
              dashboard name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Dashboard Name"
              className={`formInput ${
                formErrors?.dashboardName ? "formError" : ""
              }`}
              name="dashboardName"
              value={formValues.dashboardName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox span2">
            <label htmlFor="publicUrl" className={`formInputLabel `}>
              URL <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter URL"
              className={`formInput ${
                formErrors?.publicUrl ? "formError" : ""
              }`}
              name="publicUrl"
              value={formValues.publicUrl}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default MetabseLinkForm;